import type { GanttData } from './types';
import { addDays } from './dateUtils';

export const shiftUnresolvedTasks = (
  state: GanttData,
  daysToShift: number
): GanttData => {
  // If no shift is needed, return the original state
  if (daysToShift === 0) return state;

  const shiftedTasks = state.tasks.map(task => {
    // ⚠️ UPDATE THIS CONDITION based on your actual Task interface.
    // For example: !task.resolved, task.progress < 100, or task.status !== 'done'
    const isUnresolved = !task.isResolved;

    if (!isUnresolved) {
      return task; // Leave resolved tasks unchanged
    }

    return {
      ...task,
      // Shift both start and end dates by the same number of days 
      // to perfectly preserve the duration.
      startDate: addDays(task.startDate, daysToShift),
      endDate: addDays(task.endDate, daysToShift),
    };
  });

  return {
    ...state,
    tasks: shiftedTasks,
    // Note: We leave `state.rows` and `state.dependencies` exactly as they are.
    // The tasks remain in their currently assigned rows. 
  };
};
